import helper from '@/libs/forms';

const OPTION_EOR_PERFIX = 'deal-estimate-repairs-';
const OPTION_EOR_LARGE_PREFIX = 'deal-large-estimate-repairs-';

export default {
  softCosts: {
    schema: {
      fields: [
        helper.currency('0.1. Architect', 'architect', false, 3),
        helper.currency('0.2. Structural Engineering', 'structuralEngineering', false, 3),
        helper.currency('0.3. Mechanical Engineering', 'mechanicalEngineering', false, 3),
        helper.currency('0.4. Soils Report', 'soilsReport', false, 3),
        helper.currency('0.5. Surveying/Constr. Staking', 'surveyingConstructionStaking', false, 3),
        helper.currency('0.6. Landscaping Architect', 'landscapingArchitect', false, 3),
        helper.currency('0.7. Interior Design', 'interiorDesign', false, 3),
        helper.currency('0.8. Permit Fees', 'permitFees', false, 3),
        helper.currency('0.9. Blue Prints', 'bluePrints', false, 3),
        helper.currency('0.10. Permit Expeditor', 'permitExpeditor', false, 3),
        helper.currency('0.11. Soft Costs Contigency', 'softCostsContigency', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  generalRequirements: {
    schema: {
      fields: [
        helper.currency('1.10. Mobilization', 'mobilization', false, 3),
        helper.currency('1.15. Temporary Facilities', 'temporaryFacilities', false, 3),
        helper.currency('1.20. Asbestos/Lead Abatement', 'asbestosLeadAbatement', false, 3),
        helper.currency('1.25. Soils Inspection', 'soilsInspection', false, 3),
        helper.currency('1.30. Deputy Inspections', 'deputyInspections', false, 3),
        helper.currency('1.35. Utilities - Gas, Water, Power', 'utilities', false, 3),
        helper.currency('1.40. Construction Clean-Up', 'constructionCleanup', false, 3),
        helper.currency('1.45. Final Clean-Up', 'finalCleanup', false, 3),
        helper.currency('1.50. Site Superintendent', 'siteSuperintendent', false, 3),
        helper.currency('1.55. Project Management', 'projectManagement', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  siteConstruction: {
    schema: {
      fields: [
        helper.currency('2.10. Demolition', 'demolition', false, 4),
        helper.currency('2.15. Site Clearing', 'siteClearing', false, 4),
        helper.currency('2.20. Grade & Over-excavation', 'gradingOverExcavation', false, 4),
        helper.currency('2.25. Footing Excavation', 'footingExcavation', false, 4),
        helper.currency('2.30. Spoils Removal', 'spoilsRemoval', false, 4),
        helper.currency('2.35. Shoring', 'shoring', false, 4),
        helper.currency('2.40. Site Drainage', 'siteDrainage', false, 4),
        helper.currency('2.45. Landscaping', 'landscaping', false, 4),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  concrete: {
    schema: {
      fields: [
        helper.currency('3.10. Concrete Foundations', 'concreteFoundations', false, 3),
        helper.currency('3.15. Concrete Caissons', 'concreteCaissons', false, 3),
        helper.currency('3.20. Lightweight Concrete', 'lightweightConcrete', false, 3),
        helper.currency('3.25. Driveway', 'driveway', false, 3),
        helper.currency('3.30. Driveway approach', 'drivewayApproach', false, 3),
        helper.currency('3.35. Architectural Flatwork', 'architecturalFlatwork', false, 3),
        helper.currency('3.40. City Side Walks', 'citySideWalks', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  masonry: {
    schema: {
      fields: [
        helper.currency('4.10. Masonry Foundations', 'masonryFoundations', false, 3),
        helper.currency('4.15. Masonry Block Walls', 'masonryBlockWalls', false, 3),
        helper.currency('4.20. Masonry BBQ', 'masonryBBQ', false, 3),
        helper.currency('4.25. M. Brick Construction', 'masonryBrickConstruction', false, 3),
        helper.currency('4.30. Masonry Stone Veneer', 'masonryStoneVeneer', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  metals: {
    schema: {
      fields: [
        helper.currency('5.10. Structural Steel', 'structuralSteel', false, 3),
        helper.currency('5.15. Misc. Metals', 'miscMetals', false, 3),
        helper.currency('5.20. Architectural Metals', 'architecturalMetals', false, 3),
        helper.currency('5.25. Metal Railings', 'metalRailings', false, 3),
        helper.currency('5.30. Metal Fencing', 'metalFencing', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  woodsPlastics: {
    schema: {
      fields: [
        helper.currency('6.10. Rough Framing - Material', 'roughFramingMaterial', false, 4),
        helper.currency('6.15. Rough Framing - Labor', 'roughFramingLabor', false, 4),
        helper.currency('6.20. Exterior Siding - Material', 'exteriorSidingMaterial', false, 4),
        helper.currency('6.25. Exterior Siding - Labor', 'exteriorSidingLabor', false, 4),
        helper.currency('6.30. Finish Carpentry - Material', 'finishCarpentryMaterial', false, 4),
        helper.currency('6.35. Finish Carpentry - Labor', 'finishCarpentryLabor', false, 4),
        helper.currency('6.40. Stair Railings', 'stairRailings', false, 4),
        helper.currency('6.45. Cabinets', 'cabinets', false, 4),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  thermalMoistureProtection: {
    schema: {
      fields: [
        helper.currency('7.10. Waterproofing', 'waterproofing', false, 3),
        helper.currency('7.15. Building Insulation', 'buildInsulation', false, 3),
        helper.currency('7.20. Roofing', 'roofing', false, 3),
        helper.currency('7.25. Sheet Metal', 'sheetMetal', false, 3),
        helper.currency('7.30. Rain Gutters', 'raingGutters', false, 3),
        helper.currency('7.35. Decking Materials', 'deckingMaterials', false, 3),
        helper.currency('7.40. Shower Pans', 'showerPans', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  doorsWindows: {
    schema: {
      fields: [
        helper.currency('8.10. Exterior Doors & Windows - Material', 'exteriorDoorsWindowsMaterial', false, 4),
        helper.currency('8.15. Exterior Doors & Windows - Labor', 'exteriorDoorsWindowsLabor', false, 4),
        helper.currency('8.20. Interior Doors & Windows - Material', 'interiorDoorsWindowsMaterial', false, 4),
        helper.currency('8.25. Interior Doors & Windows - Labor', 'interiorDoorsWindowsLabor', false, 4),
        helper.currency('8.30. Door Hardware - Material', 'doorHardwareMaterial', false, 4),
        helper.currency('8.35. Door Hardware - Labor', 'doorHardwareLabor', false, 4),
        helper.currency('8.40. Cabinet Hardware - Material', 'cabinetHardwareMaterial', false, 4),
        helper.currency('8.45. Cabinet Hardware - Labor', 'cabinetHardwareLabor', false, 4),
        helper.currency('8.50. Overhead Garage Doors', 'overheadGarageDoors', false, 4),
        helper.currency('8.55. Glass Shower Enclosures', 'glassShowerEnclosures', false, 4),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  finishes: {
    schema: {
      fields: [
        helper.currency('9.10. Exterior Lath & Plaster', 'exteriorLathPlaster', false, 3),
        helper.currency('9.15. Interior Drywall', 'interiorDrywall', false, 3),
        helper.currency('9.20. Tile - Material', 'tileMaterial', false, 3),
        helper.currency('9.25. Tile - Labor', 'tileLabor', false, 3),
        helper.currency('9.30. Hardwood Flooring - Material', 'hardwoodFlooringMaterial', false, 3),
        helper.currency('9.35. Hardwood Flooring - Labor', 'hardwoodFlooringLabor', false, 3),
        helper.currency('9.40. Carpet - Material', 'carpertMaterial', false, 3),
        helper.currency('9.45. Carpet - Labor', 'carpetLabor', false, 3),
        helper.currency('9.50. Interior Painting', 'interiorPainting', false, 3),
        helper.currency('9.55. Exterior Painting', 'exteriorPainting', false, 3),
        helper.currency('9.60. Countertops', 'countertops', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  specialties: {
    schema: {
      fields: [
        helper.currency('10.10. Fireplaces', 'fireplaces', false, 3),
        helper.currency('10.15. Toilet and Bath Accessories', 'toiletBathAccessoiries', false, 3),
        helper.currency('10.20. Built in Vacuum System', 'builtVacuumSystem', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  equipment: {
    schema: {
      fields: [
        helper.currency('11.10. Theater', 'theater', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  furnishings: {
    schema: {
      fields: [
        helper.currency('12.10. Appliances', 'appliances', false, 3),
        helper.currency('12.15. Washer and Dryer', 'washerDryer', false, 3),
        helper.currency('12.20. BBQ', 'bbq', false, 3),
        helper.currency('12.25. Staging', 'staging', false, 3),
        helper.currency('12.30. Drapes/Blinds', 'drapesBlinds', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  specialConstruction: {
    schema: {
      fields: [
        helper.currency('13.10. Pools', 'pools', false, 3),
        helper.currency('13.15. Solar', 'solar', false, 3),
        helper.currency('13.20. Fire Sprinklers', 'fireSprinklers', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  conveyingSystems: {
    schema: {
      fields: [
        helper.currency('14.10. Elevators', 'elevators', false, 3),
        helper.currency('14.15. Scaffolding', 'scaffolding', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  mechanicalSystems: {
    schema: {
      fields: [
        helper.currency('15.10. Rough Plumbing', 'roughPlumbing', false, 3),
        helper.currency('15.15. Finish Plumbing - Material', 'finishPlumbingMaterial', false, 3),
        helper.currency('15.20. Finish Plumbing - Labor', 'finishPlumbingLabor', false, 3),
        helper.currency('15.25. Sewer', 'sewer', false, 3),
        helper.currency('15.30. HVAC', 'hvac', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  electrical: {
    schema: {
      fields: [
        helper.currency('16.10. Electrical Systems', 'electricalSystems', false, 3),
        helper.currency('16.15. Light Fixtures', 'lightFixtures', false, 3),
        helper.currency('16.20. Audio/Visual', 'audioVisual', false, 3),
        helper.currency('16.25. Security System', 'securitySystem', false, 3),
      ],
    },
    formOptions: helper.options(OPTION_EOR_LARGE_PREFIX, true),
  },
  description: {
    schema: {
      fields: [
        helper.textArea(
          'Description',
          'description',
          'For example, if square footage is being added or a bedroom is being created by moving walls...',
          false,
          500,
          12,
        ),
      ],
    },
    formOptions: helper.options(OPTION_EOR_PERFIX, false),
  },
  access: {
    schema: {
      fields: [
        helper.textArea(
          'Access Information',
          'description',
          'How will an inspector be able to access the property?',
          true,
          500,
          12,
        ),
      ],
    },
    formOptions: helper.options(OPTION_EOR_PERFIX, false),
  },
};



// WEBPACK FOOTER //
// ./src/components/my_deals/actions/estimate_of_repairs/resources/schema.js